import * as React from 'react';
import type { EntityFormResult } from '@goparrot-dashboard/entity-form';
import { useFormFieldProps, useInputProps } from '@goparrot-dashboard/entity-form';
import { PasswordWithConfirmationModel } from '@goparrot-dashboard-api/auth';
import { Form, Input } from '@goparrot-dashboard/shared-ui';
import { useI18n } from '@goparrot-dashboard/i18n';
import Lock from '../../../../shared-ui/src/components/icons/Lock.svg';

type PasswordFormSegmentProps<T extends Pick<PasswordWithConfirmationModel, 'password'>> = {
  form: EntityFormResult<T>;
  autoComplete?: 'new-password' | 'current-password';
  placeholder?: string;
};
export const PasswordFormSegment = <T extends Pick<PasswordWithConfirmationModel, 'password'>>({
  form,
  autoComplete = 'new-password',
  placeholder,
}: PasswordFormSegmentProps<T>): React.ReactElement => {
  const { getIntlString } = useI18n();

  const bindFormFieldProps = useFormFieldProps(form);
  const bindInputProps = useInputProps(form);

  const passwordRawProps = bindInputProps('password');

  return (
    <Form.OutlinedFormField {...bindFormFieldProps('password')}>
      <label htmlFor="password" className="tw-hidden">
        {getIntlString('label.password')}
      </label>
      <div className="tw-mt-4">
        <Input
          variant="market"
          id="password"
          name="password"
          type="password"
          autoComplete={autoComplete}
          className="tw-w-full"
          data-testid="password-input"
          placeholder={placeholder ?? getIntlString('placeholder.newPassword')}
          leadingAccessory={Lock}
          {...passwordRawProps}
          onChange={(e: React.ChangeEvent<{ value?: string }>) => {
            e.persist();
            passwordRawProps.onChange(e?.target?.value);
          }}
        />
      </div>
    </Form.OutlinedFormField>
  );
};
